<script lang="ts" setup>
import { computed, type CSSProperties } from 'vue'

import type { GridAlignment } from '@/types/serverGrid.type'

const props = defineProps<{
  area?: string | undefined
  classes?: string | undefined
  horizontalAlign?: GridAlignment | undefined
  verticalAlign?: GridAlignment | undefined
  maxWidth?: string | undefined
}>()

const style = computed<CSSProperties>(() => ({
  gridArea: props.area,
  justifySelf: props.horizontalAlign,
  alignSelf: props.verticalAlign,
  // Поле занимает доступную ширину, но не превышает заданное ограничение.
  width: props.maxWidth ? '100%' : undefined,
  maxWidth: props.maxWidth
}))
</script>

<template>
  <div
    :class="['layout-grid__item', classes]"
    :style="style"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.layout-grid__item {
  min-width: 0;
  align-content: start;
}
</style>
